import CrudCustom from '../../../libs/custom/CrudCustom';

let MasterLevelService = new CrudCustom('/level-pegawai');
export default MasterLevelService;
